import { ChangeDetectionStrategy, Component, inject, OnInit, Signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  BottomNavbarComponent,
  InputWithIconComponent,
  PageLayoutComponent,
  TitileNavbarComponent
} from '@ui-components';
import { IonicModule } from '@ionic/angular';
import { Channel } from 'stream-chat';
import { ChannelListItemComponent } from './channel-list-item/channel-list-item.component';
import { ChannelListItemViewService } from './channel-list-item/view-service/channel-list-item.view-service';
import { ChatsListViewService } from './view-service/chats-list.view-service';
import { SkeletonsModule } from '@ui-components';

@Component({
  selector: 'lib-chats-list',
  templateUrl: './chats-list.component.html',
  styleUrls: ['./chats-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TitileNavbarComponent,
    BottomNavbarComponent,
    IonicModule,
    ReactiveFormsModule,
    InputWithIconComponent,
    ChannelListItemComponent,
    SkeletonsModule,
    PageLayoutComponent
  ],
  providers: [ChatsListViewService, ChannelListItemViewService]
})
export class ChatsListComponent implements OnInit {
  private readonly viewService: ChatsListViewService = inject(ChatsListViewService);

  readonly searchControl: FormControl<string> = new FormControl<string>('', { nonNullable: true });

  readonly isLoading: Signal<boolean> = this.viewService.isLoading;
  readonly isChatAvailable: Signal<boolean | undefined> = this.viewService.isChatAvailable;
  readonly channels: Signal<Channel[] | undefined> = this.viewService.filteredChannels;
  readonly searchTerm: Signal<string> = this.viewService.searchTerm;
  readonly channelsVersion: Signal<number> = this.viewService.channelsVersion;

  ngOnInit(): void {
    this.viewService.initChat();

    this.searchControl.valueChanges.subscribe((value: string) => this.viewService.setSearchTerm(value));
  }

  selectChannel(channel: Channel): void {
    this.viewService.selectChannel(channel);
  }

  trackByChannelId(_index: number, channel: Channel): string {
    return channel.id || String(_index);
  }
}
